export default "__VITE_ASSET__iqu4Tu5$__"